import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSpecialFilter } from "../../ducks/table/selectors";
import { updateSpecialFilter } from "../../ducks/table/table";

import { TableSpecialFilter } from "../../ducks/table/types";

export const useTableSpecialFilter = (): [TableSpecialFilter, (value?: TableSpecialFilter) => void] => {
  const dispatch = useDispatch();
  const specialFilter = useSelector(getSpecialFilter);

  const update = useCallback(
    (value?: TableSpecialFilter) => {
      dispatch(updateSpecialFilter(value));
    },
    [dispatch],
  );

  return [specialFilter, update];
};
